import { useEffect, useRef, useState } from 'react';
import horaireData from '../data/horaire.json';
import { DEFAULT_CONTACT } from '../components/ModaleContact/ModaleContact';

export const HORAIRE_FALLBACK = horaireData.horaire || '/*mercredi*/, /*vendredi*/ 10h - 13h30 | 15h-19h<br/>/*jeudi*/ 15h-19h | /*samedi*/ 10h-15h';

export function useScrollAnimation(options = {}) {
    const ref = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const element = ref.current;
        if (!element) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.unobserve(element);
                }
            },
            {
                threshold: options.threshold || 0.1,
                rootMargin: options.rootMargin || '0px 0px -50px 0px',
            }
        );

        observer.observe(element);

        return () => {
            if (element) observer.unobserve(element);
        };
    }, [options.threshold, options.rootMargin]);

    return [ref, isVisible];
}

// Texte des horaires (repli local, puis valeur de l'adminpanel si disponible).
export function useHoraire() {
    const [horaire, setHoraire] = useState(HORAIRE_FALLBACK);
    useEffect(() => {
        fetch('/api/horaire')
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => { if (data && data.horaire) setHoraire(data.horaire); })
            .catch(() => {});
    }, []);
    return horaire;
}

// Coordonnées de contact (repli local, puis valeur de l'adminpanel si disponible).
export function useContactInfo() {
    const [contact, setContact] = useState(DEFAULT_CONTACT);
    useEffect(() => {
        fetch('/api/contact')
            .then((r) => (r.ok ? r.json() : null))
            .then((data) => { if (data && data.telephone) setContact(data); })
            .catch(() => {});
    }, []);
    return contact;
}

// Heure courante rafraîchie chaque minute (pour le statut Ouvert / Fermé).
export function useNow(intervalMs = 60000) {
    const [now, setNow] = useState(() => new Date());
    useEffect(() => {
        const id = setInterval(() => setNow(new Date()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);
    return now;
}
